import { render, staticRenderFns } from "./GridRow.vue?vue&type=template&id=13a6bd16&scoped=true"
import script from "./GridRow.vue?vue&type=script&lang=js"
export * from "./GridRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a6bd16",
  null
  
)

export default component.exports